export default "__VITE_ASSET__Ds$i9aD6__"